<script setup>

import { defineProps, defineEmits, ref, computed} from "vue";
import ContasAReceberRecebimentosService from "@/api/v2/services/ContasAReceberRecebimentosService";
import UtilNumber from "@/utils/UtilNumber";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "controlesDesativados",
    "dado",
    "recebimentoNovo",
    "contaAReceberValorOriginal",
    "contaAReceberValorVinculado",
    "contaAReceberSaldoAVincular",
    "notaFiscalEmitidaValorOriginal",
    "notaFiscalEmitidaValorRecebido",
    "notaFiscalEmitidaValorParaReceber",
]);

const emits = defineEmits([
    "update:alteraControlesDesativados",
    "update:alteraVincularNotaFiscal"
]);

//==================================================================//
//=================== Vincular Nota Fiscal Loading =================//
//==================================================================//

const vincularNotaFiscalLoading = ref(false);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//================= Altera Vincular Nota Fiscal ====================//
//==================================================================//

const alteraVincularNotaFiscal = (update)=>{

    emits('update:alteraVincularNotaFiscal',update);

};

//==================================================================//
//================= Desativa Vincular Nota Fiscal ==================//
//==================================================================//

const desativaVincularNotaFiscal = computed(()=>{

    // Controles Desativados
    if(props?.controlesDesativados == true){
        return true
    }

    // Nota Fiscal Emitida
    if(!props?.recebimentoNovo?.notaFiscalEmitida?.id){
        return true;
    }

    // CA - Valor Vinculado
    if(props?.contaAReceberValorVinculado < 0 || props?.contaAReceberValorVinculado > props?.contaAReceberValorOriginal){
        return true;
    }

    // CA - Saldo a Vincular
    if(props?.contaAReceberSaldoAVincular < 0 || props?.contaAReceberSaldoAVincular > props?.contaAReceberValorOriginal){
        return true;
    }

    //NF - Valor Recebido
    if(props?.notaFiscalEmitidaValorRecebido < 0 || props?.notaFiscalEmitidaValorRecebido > props?.notaFiscalEmitidaValorOriginal){
        return true;
    }

    //NF - Valor para Receber
    if(props?.notaFiscalEmitidaValorParaReceber < 0 || props?.notaFiscalEmitidaValorParaReceber > props?.notaFiscalEmitidaValorOriginal){
        return true;
    }

    // Porcentagem Vinculo
    if(props?.recebimentoNovo?.porcentagemRecebimento <= 0 || props?.recebimentoNovo?.porcentagemRecebimento > 100){
        return true;
    }

    // Valor Recebimento
    if(props?.recebimentoNovo?.valorRecebimento <= 0 || props?.recebimentoNovo?.valorRecebimento > props?.notaFiscalEmitidaValorOriginal){
        return true;
    }

    return false;

});

//==================================================================//
//============= Altera Vincular Nota Fiscal Loading ================//
//==================================================================//

const alteraVincularNotaFiscalLoading = (update)=>{

    vincularNotaFiscalLoading.value = update;

};

//==================================================================//
//========================= Fecha Modal ============================//
//==================================================================//

const fechaModal = () => {

    alteraVincularNotaFiscal({
        vincularNotaFiscal: false
    });

};

//==================================================================//
//========================= Fecha Modal ============================//
//==================================================================//

const aoFecharModal = () => {

    fechaModal();
    
};

//==================================================================//
//================ Ao Vincular Nota Fiscal =========================//
//==================================================================//

const aoVincularNotaFiscal = async () => {

    alteraVincularNotaFiscalLoading(true);
    alteraControlesDesativados(true);

    let vinculoValores = {
        contaAReceberAvulsa: props?.dado?.id,
        notaFiscalEmitida:  props?.recebimentoNovo?.notaFiscalEmitida?.id,
        porcentagemRecebimento: props?.recebimentoNovo?.porcentagemRecebimento,
        valorRecebimento: props?.recebimentoNovo?.valorRecebimento,
    };

    let contasAReceberVinculoResponse = await ContasAReceberRecebimentosService.criarVinculo(vinculoValores);
    if(contasAReceberVinculoResponse.status != 200){
        throw new Error("Falha ao Gerar o Vinculo de Conta a Receber Avulsa e Nota Fiscal Emitida");
    }
    
    alteraControlesDesativados(false);
    alteraVincularNotaFiscalLoading(false);

    fechaModal();

};

</script>

<template>

    <div class="c-barra">

        <v-btn
            class="c-barra__botao-fechar"
            color="error"
            dark
            :disabled="props?.controlesDesativados"
            @click="aoFecharModal"
        >
            Fechar
        </v-btn>

        <p class="c-barra__titulo">

            <span class="c-barra__titulo-texto">

                <v-icon color="white" large>
                    mdi-invoice-list-outline
                </v-icon>

                Vincular Nota Fiscal

            </span>
                
        </p>

        <v-chip
            class="c-barra__usuario"
            color="primary"
            label
        >

            <v-icon left>
                mdi-account-circle-outline
            </v-icon>
            Usuario:
            {{colaboradorStore?.colaborador?.nome}}

        </v-chip>

        <div class="c-barra__controles">

            <v-btn
                class="c-botao-vincular-nota-fiscal"
                color="primary"
                dark
                :disabled="desativaVincularNotaFiscal"
                :loading="vincularNotaFiscalLoading"
                @click="aoVincularNotaFiscal"
            >
                Vincular Nota Fiscal
            </v-btn>

        </div>

    </div>

</template>

<style scoped>

.c-barra{
    display: grid;
    position: sticky;
    z-index: 1;
    top: 0;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: min-content min-content;
    grid-template-areas: 
    "botaoFechar titulo titulo titulo ."
    "usuario usuario controles controles controles";
    align-items: center;
    gap: 10px;
    padding: 6px 16px !important;
    margin: 0px 0 4px 0px !important;
    border-color: #26252b !important;
    background-color: #230bc1 !important;
    color: #FFFFFF;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-barra__botao-fechar{
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-vincular-nota-fiscal{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

.c-barra__botao-fechar {
    align-self: baseline;
    width: min-content;
}

.c-barra__titulo{
    grid-area: titulo;
    align-self: center;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    font-size: 1.25rem !important;
    font-weight: 500 !important;
    margin: auto;
    gap: 5px;
}

.c-barra__titulo-texto{
    text-align: center;
}

.v-chip.v-size--default{
    height: auto;
}

.c-barra__usuario {
    grid-area: usuario;
    align-self: baseline;
    padding: 5px 15px;
    white-space: normal;
    width: auto;
    margin-right: auto;
}

.c-barra__controles{
    grid-area: controles;
    gap:10px;
    display: flex;
    justify-content: flex-end;
}

</style>